export const BUSINESS_PARTNER_CENTER_TRANSLATIONS_DE = {
  overview: 'Übersicht',
  'master-data': 'Stammdaten',
  activities: 'Aktivitäten',
  contacts: 'Kontakte',
  orders: 'Aufträge',
  budget: 'Budgets',
  appointments: 'Termine',
  ratings: 'Bewertungen',
  planning: 'Planung',
  documentations: 'Dokumentationen',
  'contract-data': 'Vertragsdaten',
  'working-hours': 'Arbeitszeiten',
  workContract: 'Arbeitsvertrag',
  files: 'Dateien',
  tickets: 'Aufgaben',
  other: 'Sonstiges',
  controlling: 'Controlling',
  employees: 'Mitarbeiter',
  mobility: 'Mobilität',
  'payroll-data': 'Lohnabrechnung',
  absences: 'Abwesenheiten',
};
